import { useEdgeBulkPatchOffer, useEdgeSubmitOffer } from './useEdgeDataFetcher'
import CookieHelper from '../utils/CookieHelper'
import { SummaryPageNumber, ContactPageNumber, LoadingPageNumber, CertificatePageNumber } from '../constants'
import { fireEventReady } from '../analytics/events'
import { useGlobalState } from './GlobalStateProvider'
import { BrowserUtils } from '../utils/siteUtils'
import { getOfferErrorEventName } from '../analytics/util'

export default (landingContext, updateGlobalState) => {
  const expired = landingContext.offer && (landingContext.offer.status === 'EXPIRED' || landingContext.offer.status === 'EXPIRED_RESUBMIT' || landingContext.offer.isExpired)
  const isAdmin = landingContext.experienceState.isAdmin
  const shouldShowOfferCreationComponent = landingContext.experienceState.shouldShowOfferCreationComponent
  if (!landingContext.globalState.termsAccepted && landingContext.urlState.p > SummaryPageNumber && landingContext.urlState.p < CertificatePageNumber && !landingContext.offer && !isAdmin) {
    landingContext.urlState.p = ContactPageNumber
    landingContext.urlState.pp = (landingContext.urlState.pp || 0) + 1 //need to set another variable so that next click to p=8 again will trigger a url change
  }

  const canSubmit = landingContext.urlState.p === LoadingPageNumber && landingContext.prospectDocuments && landingContext.prospectDocuments.documents && landingContext.lambdaData //make sure lambda ip data is fetched
  const questions = shouldShowOfferCreationComponent ? false : canSubmit && getQuestions(landingContext)
  let offerError = undefined
  if (shouldShowOfferCreationComponent) {
    //Send offer code errors when offer creation flag is on and is not Admin. Will show appropriate errors on component funnel contact page
    setOfferDataFromWebComp(landingContext, updateGlobalState)
  }

  const [patchData, patchError] = useEdgeBulkPatchOffer(landingContext.prospectId, questions)
  const dataReady = typeof window !== 'undefined' && window.ICO && window.ICO.dataLayer
  const { globalState } = useGlobalState()

  const [offerSubmitData, offerSubmitError] = useEdgeSubmitOffer(patchData && patchData.success && landingContext.prospectId)

  // If isAdmin(DAT) or expired or offer creation component flag is off
  const isOfferCreationComponentEnabled = landingContext.globalState.isOfferCreationComponentEnabled
  const isOfferCreationComponentEnabledDAT = !(expired || isAdmin) || landingContext.globalState.isOfferCreationComponentDatEnabled
  const shouldUseFurySubmitOffer = !isOfferCreationComponentEnabled || !isOfferCreationComponentEnabledDAT

  if (shouldUseFurySubmitOffer) {
    const consumerInfoToggle = globalState.consumerInfoToggle
    if (consumerInfoToggle && questions && dataReady && patchData) {
      const EVENT = 'SendPixallWithConsumerInfo'
      const dataLayer = typeof window !== 'undefined' && window.ICO ? window.ICO.dataLayer : {}

      var contactInfo = null
      if (questions.bulkAnswers) {
        contactInfo = questions.bulkAnswers.find(function (el) {
          return el.canonicalName === 'contactInfo'
        })
      }

      if (contactInfo && contactInfo.answers) {
        dataLayer.contactInfo = {
          email: contactInfo.answers.email,
          phone: contactInfo.answers.phone,
          firstName: contactInfo.answers.firstName,
          lastName: contactInfo.answers.lastName
        }

        if (patchData.success) {
          dataLayer.contactInfo.consumerId = patchData.submitAnswersResponse && patchData.submitAnswersResponse.consumerResponse ? patchData.submitAnswersResponse.consumerResponse.consumerId : null
        }
        var pageInfo = dataLayer.pageInfo ? dataLayer.pageInfo.page : ''
        fireEventReady(pageInfo, EVENT, dataLayer)
      }
    }

    offerError = patchError && patchError[0]

    if (patchError) {
      if (patchError.includes(400084)) {
        updateGlobalState({ phoneError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
      if (patchError.includes(400080)) {
        updateGlobalState({ firstNameError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
      if (patchError.includes(400081)) {
        updateGlobalState({ lastNameError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
    }
    landingContext.patchError = offerError

    offerError = offerSubmitError && offerSubmitError[0]

    if (offerSubmitError) {
      if (offerSubmitError.includes(400082)) {
        updateGlobalState({ emailError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
      if (offerSubmitError.includes(400084)) {
        updateGlobalState({ phoneError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
      if (offerSubmitError.includes(400080)) {
        updateGlobalState({ firstNameError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
      if (offerSubmitError.includes(400081)) {
        updateGlobalState({ lastNameError: true, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }

      const errorEvent = getOfferErrorEventName(offerError)
      if (errorEvent && patchData?.success) {
        updateGlobalState({ fireAnalytics: errorEvent, error: true })
        // Default set offer Error is ContactInfoNotAnsweredInFull
        offerError = 400092
      }
    }

    if (offerError) landingContext.offerError = offerError
    //When this is set we know we have finished submitting a new offer. all edit offer id checks should probably use this unless they want the original offer id
    landingContext.offerId = offerSubmitData && offerSubmitData.offerId
    if (offerSubmitData && offerSubmitData.offerId) {
      landingContext.offer = offerSubmitData

      const offerCertificate = {
        offerCertificate: {
          offerId: offerSubmitData.offerId,
          amount: offerSubmitData.amount,
          status: offerSubmitData.status,
          expirationDate: offerSubmitData.expirationDate,
          offerCode: landingContext.experienceState && landingContext.experienceState.offerCode ? landingContext.experienceState.offerCode.toUpperCase() : '',
          markupAmounts: offerSubmitData.markupAmounts,
          totalOfferAmounts: offerSubmitData.totalOfferAmounts
        }
      }
      BrowserUtils.postMessage(JSON.stringify(offerCertificate), '*')
    } else {
      landingContext.offerBeingSubmitted = true
    }
  }
}

const setOfferDataFromWebComp = (landingContext, updateGlobalState) => {
  let offerErrorsFromWebComp = []
  offerErrorsFromWebComp = { ...landingContext.globalState.offerErrorsFromWebComp }
  let offerWebCompError = offerErrorsFromWebComp && Object.values(offerErrorsFromWebComp)[0]

  if (Object.keys(offerErrorsFromWebComp).length) {
    if (Object.values(offerErrorsFromWebComp).includes(400082)) {
      updateGlobalState({ emailError: true, error: true })
      // Default set offer Error is ContactInfoNotAnsweredInFull
      offerWebCompError = 400092
    }
    if (Object.values(offerErrorsFromWebComp).includes(400084)) {
      updateGlobalState({ phoneError: true, error: true })
      // Default set offer Error is ContactInfoNotAnsweredInFull
      offerWebCompError = 400092
    }
    if (Object.values(offerErrorsFromWebComp).includes(400080)) {
      updateGlobalState({ firstNameError: true, error: true })
      // Default set offer Error is ContactInfoNotAnsweredInFull
      offerWebCompError = 400092
    }
    if (Object.values(offerErrorsFromWebComp).includes(400081)) {
      updateGlobalState({ lastNameError: true, error: true })
      // Default set offer Error is ContactInfoNotAnsweredInFull
      offerWebCompError = 400092
    }
  }
  if (offerWebCompError) landingContext.offerError = offerWebCompError

  let offerSubmitDataFromComp = landingContext.globalState.offerDataFromWebComp
  landingContext.offerId = offerSubmitDataFromComp && offerSubmitDataFromComp.offerId

  if (offerSubmitDataFromComp) landingContext.offer = offerSubmitDataFromComp
  else landingContext.offerBeingSubmitted = true
}

const getQuestions = ({ prospectDocuments, urlState, qxData, globalState, experienceState, offer, consumerGenerated }, updateGlobalState) => {
  const map = { qx: 'other', qc: 'conditions', qp: 'history', paintmeter: 'qmeter', qui: 'contactInfo', qrv: 'replacementVehicle' }
  const conditionQuestions = prospectDocuments.documents.find(item => item.canonicalName === 'conditions').items
  const historyQuestions = prospectDocuments.documents.find(item => item.canonicalName === 'history').items
  //handles qc and qp

  const offerVars = offer ? [].concat(offer.prospect.history).concat(offer.prospect.conditions) : []
  const offerState = offerVars.reduce((acc, curQues) => {
    const localAcc = acc
    if (curQues.value || curQues.value === false || curQues.value === 0) {
      if (curQues.questionType === 'Boolean' || curQues.questionType === 'Enum') {
        const index = (curQues.enumChoices.length ? curQues.enumChoices : [true, false]).findIndex(answer => answer === curQues.value)
        localAcc[curQues.questionId] = { v: index }
      } else if (curQues.questionType === 'ToggleSelect' && curQues.value === 'True') {
        localAcc[curQues.questionId] = { v: 0 }
        if (curQues.acceptsComment) localAcc[curQues.questionId].c = curQues.comment
      } else {
        localAcc[curQues.questionId] = { v: curQues.value }
      }
    } else if (curQues.selectChoices && curQues.selectChoices.length) {
      if (curQues.questionType === 'SingleSelect') {
        const choice = curQues.selectChoices.find(curQ => curQ.selected)
        const index = curQues.selectChoices.findIndex(curQ => curQ.selected)
        localAcc[curQues.questionId] = { v: index }
        if (choice.acceptsComment) localAcc[curQues.questionId].c = choice.comment
      }
      if (curQues.questionType === 'MultiSelect') {
        curQues.selectChoices.forEach(curQ => {
          if (curQ.selected) localAcc[curQ.qRef] = { v: 0 }
          if (curQ.selected && curQ.acceptsComment) localAcc[curQ.qRef].c = curQ.comment
        })
      }
    }
    return localAcc
  }, {})

  const rvState = offer ? convertRvOfferAnswers(offer && offer.prospect && offer.prospect.replacementVehicle) : {}

  //TODO: Maybe we should try doing this merging when the offer is loaded and then not needing to specify a difference.
  const localState = { ...offerState, ...rvState }
  Object.keys(urlState).forEach(key => {
    const offerComment = localState[key] && localState[key].c
    const questionAnswered = localState[key] && (localState[key].v === 0 || localState[key].v)
    localState[key] = urlState[key]
    if (offerComment && questionAnswered && !localState[key].c) localState[key].c = offerComment
  })
  const answers = Object.keys(localState)
    .filter(item => Object.keys(map).find(key => key === item.split('/')[0]) && item.split('/')[0] !== 'qrv') //filters out non-questionairre related state and filters RV
    .map(questionId => {
      const question = conditionQuestions.concat(historyQuestions).find(question => question.questionId === questionId) || conditionQuestions.find(question => questionId.startsWith(question.questionId)) // gets question for bool/enum/toggle select || gets root question for multi/single select
      const addition = (question && question.questionType === 'SingleSelect' && `/${localState[question.questionId].v + 1}`) || ''
      const comment = localState[questionId].c && { comment: localState[questionId].c }
      let value =
        (question && (question.questionType === 'SingleSelect' || question.questionType === 'MultiSelect' || question.questionType === 'ToggleSelect') && (localState[questionId].v ? true : localState[questionId].v === 0 ? true : 'undefined')) ||
        ((question.questionType === 'Boolean' || question.questionType === 'Enum') && (question.enumChoices.length ? question.enumChoices : [true, false])[localState[questionId].v]) ||
        (question.questionType === 'Integer' && localState[questionId].v)
      if (questionId === 'qc/ConditionTierSelection') {
        value = localState[questionId].v
      }
      return value !== null && value !== undefined && value !== 'undefined' && { canonicalName: map[questionId.split('/')[0]], answers: [{ questionId: questionId + addition, value, ...comment, type: question && question.questionType }] }
    })
    .filter(v => !!v)
    .reduce((acc, cur) => {
      const ind = acc.findIndex(elem => elem.canonicalName === cur.canonicalName)
      if (ind !== -1) acc[ind].answers = acc[ind].answers.concat(cur.answers)
      else acc.push(cur)
      return acc
    }, [])
  if (qxData) {
    const dealerComment = qxData.find(data => data.questionId === 'qx/UserComments')
    dealerComment.value = localState.dealerComment || (offer && offer.prospect && offer.prospect.dealerComment)
    const consumerGeneratedQuestion = qxData.find(data => data.questionId === 'qx/ConsumerGenerated')
    consumerGeneratedQuestion.value = offer ? !!consumerGenerated : !experienceState.isAdmin
    const offerCode = qxData.find(data => data.questionId === 'qx/OfferCode')
    offerCode.value = offer ? offer.offerCode : offerCode.value
    const pixallId = qxData.find(data => data.questionId === 'qx/PixAllID')
    pixallId.value = experienceState.includePixall ? CookieHelper.get('abc') || CookieHelper.get('pxa_id') || '' : ''
    pixallId.value = pixallId.value.match(/[^A-Z0-9]/gi) ? '' : pixallId.value
    const pixallRealId = qxData.find(data => data.questionId === 'qx/PixAllRealID')
    pixallRealId.value = experienceState.includePixall ? CookieHelper.get('pxa_realid') || '' : ''
  }

  answers.push({ canonicalName: 'other', answers: qxData })
  localState['qmeter'] && answers.push({ canonicalName: 'paintMeter', answers: localState['qmeter'].v || [] })

  //check if conditions exist
  !answers.find(e => e.canonicalName === map.qc) && answers.push({ canonicalName: map.qc, answers: [] })

  const emailCustomerCheckbox = experienceState.dealerInfo ? experienceState.dealerInfo.sendEmail : true

  const showContact = !experienceState.isAdmin ? true : experienceState.dealerInfo.isConsumerOffer || (offer && offer.prospect && offer.prospect.isConsumerOffer) ? true : false

  const getProp = prop => {
    const contactOption1 = globalState[prop]
    const contactOption2 = experienceState.customerInfo && experienceState.customerInfo[prop]
    const contactOption3 = offer && offer.prospect.contactInfo[prop]
    return contactOption1 || contactOption2 || contactOption3 || undefined
  }
  if (showContact)
    answers.push({
      canonicalName: 'contactInfo',
      answers: {
        firstName: getProp('firstName'),
        lastName: getProp('lastName'),
        zip: getProp('zip'),
        email: getProp('email'),
        confirmEmail: getProp('email'),
        phone: getProp('phone'),
        legalAcceptance: !!experienceState.isAdmin || !!globalState.termsAccepted,
        emailCustomerCheckbox
      }
    })
  answers.push(getRvAnswers(localState, experienceState && experienceState.isAssigned))
  let hasAllContactInfoAnswers = experienceState.isAdmin
  if (!hasAllContactInfoAnswers) {
    const answersContactInfo = answers.find(item => item.canonicalName === 'contactInfo').answers
    const answersContactInfoCount = Object.values(answersContactInfo).filter(v => !!v).length
    const prospectDocumentsContactInfo = prospectDocuments.documents.find(item => item.canonicalName === 'contactInfo').items.required
    const prospectDocumentsContactInfoCount = prospectDocumentsContactInfo.length
    hasAllContactInfoAnswers = answersContactInfoCount >= prospectDocumentsContactInfoCount
  }
  return hasAllContactInfoAnswers && { bulkAnswers: answers }
}

//TODO: should be simplified when questionnaire updated
const convertRvOfferAnswers = offerRvState => {
  const qrv = ['qrv/LeadType', 'qrv/LookingForNewCars', 'qrv/LookingForCertifiedCars', 'qrv/LookingForUsedCars', 'qrv/MakeModel1', 'qrv/YearRange']

  const rvAnswers =
    offerRvState &&
    offerRvState.filter(q => q.questionId === 'qrv/LeadType')[0].value === 'OptIn' &&
    offerRvState.reduce((acc, curr) => {
      const localAcc = acc
      if (qrv.includes(curr.questionId)) {
        localAcc[curr.questionId] = curr.questionType === 'IntegerRange' ? { c: curr.min.concat(',', curr.max) } : { v: curr.value }
      } else if (curr.questionType === 'Subquestion') {
        curr.subquestions
          .filter(q => qrv.includes(q.questionId))
          .filter(q => q.value)
          .forEach(subQ => {
            localAcc[subQ.questionId] = { c: subQ.value }
          })
      }
      return localAcc
    }, {})
  return rvAnswers
}
//TODO: should be simplified when questionnaire updated
const getRvAnswers = (urlState, isAssigned) => {
  const optInQ = 'qrv/LeadType'
  const rvFlag = Object.keys(urlState).filter(item => item === optInQ)

  const rvAnswers =
    urlState[rvFlag] && urlState[rvFlag].v === 'OptIn'
      ? [
          ...Object.keys(urlState)
            .filter(item => item.split('/')[0] === 'qrv')
            .map(q => {
              const val = urlState[q].c ? urlState[q].c : urlState[q].v === 0 ? true : urlState[q].v === 1 ? false : urlState[q].v
              return val && { questionId: q, value: val }
            }),
          {
            questionId: 'qrv/AnyBodyStyle',
            value: true
          },
          {
            questionId: 'qrv/CreditScore',
            value: 'creditScore/0'
          },
          {
            questionId: 'qrv/TimeFrame',
            value: 'timeFrame/0'
          }
        ]
      : [{ questionId: optInQ, value: urlState[rvFlag] ? urlState[rvFlag].v : !!isAssigned ? 'OptOut' : 'CashOffer' }]

  return { canonicalName: 'replacementVehicle', answers: rvAnswers.filter(x => !!x) }
}
